var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white position-relative pt-3 pb-3"},[_c('Loader',{attrs:{"visible":_vm.isLoading}}),_c('router-link',{attrs:{"to":"/home/procedure"}},[_c('b-button',{},[_vm._v("Quay lại")])],1),_c('div',{staticClass:"image-scroll"},[_c('img',{attrs:{"src":_vm.procedureItemDetail.imageUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }